/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { isFunction } from "@adapptio/lib-shared";

export function setRef<T>(
	ref: React.MutableRefObject<T | null> | ((instance: T | null) => void) | null | undefined,
	value: T | null
): void {
	if (isFunction(ref)) {
		ref(value);
	} else if (ref) {
		ref.current = value;
	}
}
